"use client";
import { useEffect, useRef, useState } from 'react';

export function useScrollAnimation(threshold = 0.1) {
  const ref = useRef<HTMLElement>(null);
  // Start with true to prevent flash of invisible content, 
  // then let the animation class handle the actual animation
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) return;

    // Check if element is already in viewport on mount
    const rect = currentRef.getBoundingClientRect();
    const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
    
    if (isInViewport) {
      setIsVisible(true);
      return;
    }

    // If not in viewport, set to false and observe
    setIsVisible(false);
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold,
        rootMargin: '50px',
      }
    );

    observer.observe(currentRef);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold]);

  return { ref, isVisible };
}
